/* eslint-disable */
import React, { Component, PropTypes } from 'react';
import { withFormik } from 'formik';
import { connect } from 'react-redux';
import Yup from 'yup';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash.isempty';
import { geti18n } from '../../utils';
import statesSelectList from './states.json';
import './reset.scss';
import SelectArrowSvg from './SelectArrowSvg';
import SearchSvg from './SearchSvg';
import ErrorSvg from './ErrorSvg';
import TextLink from '../TextLink';
import { updateZipCodeAction } from '../../redux/actions/zipCode';
import { getCurrentZipCode } from '../../redux/selectors/dma';
import { getBrandFromState } from '../../redux/selectors';
import {
  FormStyled,
  FormLabelOuterWrapperStyled,
  FormLabelInnerWrapperStyled,
  FormLabelCopyStyled,
  FormLabelCopyAddOnStyled,
  FormLabelSvgAddOnStyled,
  FormInputStyled,
  FormSelectStyled,
  FormButtonWrapperStyled,
  FormInlineErrorWrapperStyled,
  FormInlineErrorStyled,
  FormInlineErrorCopyStyled,
  FormInlineErrorSvgWrapperStyled,
  GenericFormErrorStyled,
  GenericFormErrorSvgStyled,
  PrivacyPolicyStyled,
  StyledInfoTextWrapper,
  StyledInfoText
} from './styles';
import Button from '../Button';

export const FIELD_NAMES = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ADDRESS: 'address',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'postalCode',
  EMAIL: 'email',
  NEWS: 'news',
  PHONE: 'phone'
};

export const ROOT_ELEMENT = document ? document.getElementById('nna-payment-estimator') : null;

class FormMarkup extends Component {

  static propTypes = {
    optionalText: PropTypes.string,
    privacyPolicy: PropTypes.string,
    privacyPolicyURL: PropTypes.string,
    unknownError: PropTypes.string,
    infoText: PropTypes.string,
    requiredText: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    optIn: PropTypes.string,
    submitButton: PropTypes.string,
    brandName: PropTypes.string.isRequired
  }

  static defaultProps = {
    optionalText: geti18n('leadsFormContent.leadsForm.optionalText'),
    privacyPolicy: geti18n('leadsFormContent.leadsForm.privacyPolicy'),
    privacyPolicyURL: geti18n('leadsFormContent.leadsForm.privacyPolicyURL'),
    unknownError: geti18n('leadsFormContent.leadsForm.unknownError'),
    infoText: geti18n('leadsFormContent.leadsForm.infoText'),
    requiredText: geti18n('leadsFormContent.leadsForm.requiredText'),
    firstName: geti18n('leadsFormContent.leadsForm.firstName'),
    lastName: geti18n('leadsFormContent.leadsForm.lastName'),
    address: geti18n('leadsFormContent.leadsForm.address'),
    city: geti18n('leadsFormContent.leadsForm.city'),
    state: geti18n('leadsFormContent.leadsForm.state'),
    zipCode: geti18n('leadsFormContent.leadsForm.zipCode'),
    email: geti18n('leadsFormContent.leadsForm.email'),
    phone: geti18n('leadsFormContent.leadsForm.phone'),
    optIn: geti18n('leadsFormContent.leadsForm.optIn'),
    submitButton: geti18n('leadsFormContent.leadsForm.submitButton'),
    brandName: ''
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (isEmpty(this.props.formErrors) && !isEmpty(nextProps.formErrors)) {
      this.props.setErrors(nextProps.formErrors);
      // server error
      this.scrollToRoot();
    }

    // if (this.props.isSubmitting && !this.props.isValid) {
    //   this.props.formErrorCallback(this.props.errors);
    //   // client-side error
    //   this.scrollToRoot();
    // }
  }

  componentDidUpdate() {
    // server error
    if (this.props.genericErrors) {
      this.scrollToRoot();
    }
  }

  scrollToRoot = () => {
    if (ROOT_ELEMENT) {
      ROOT_ELEMENT.scrollIntoView();
    }
  };

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      firstName,
      lastName,
      address,
      city,
      state,
      zipCode,
      email,
      phone,
      optIn,
      unknownError,
      infoText,
      requiredText,
      submitButton,
      brandName
    } = this.props;
    const renderFieldError = (field) => {
      return errors[field.name] && touched[field.name] ? field.name : undefined;
    };

    const renderFormInput = (field) => {
      return (
        <FormInputStyled
          name={field.name}
          id={field.id}
          placeholder={field.placeholder}
          type={field.type}
          value={values[field.name]}
          maxLength={field.maxLength}
          checked={values[field.name] === true}
          onChange={field.onChange || handleChange}
          onBlur={handleBlur}
          fieldError={renderFieldError(field)}
          onKeyDown={field.onKeyDown}
          autoComplete={field.autoComplete}
        />
      );
    };

    const renderFormSelect = (field) => {
      return (
        <FormSelectStyled
          name={field.name}
          id={field.id}
          onChange={handleChange}
          onBlur={handleBlur}
          fieldError={renderFieldError(field)}
          autoComplete={field.autoComplete}
        >
          {statesSelectList.map((state) => (
            <option value={state.abbreviation} key={state.abbreviation}>
              {state.abbreviation}
            </option>
          ))}
        </FormSelectStyled>
      );
    };

    const renderCheckboxLabel = (field) => {
      if (field.type === 'checkbox')
        return (
          <FormLabelOuterWrapperStyled htmlFor={field.id}>
            <span />
          </FormLabelOuterWrapperStyled>
        );
    };

    const renderPhoneLabelCopyAddOn = () => {
      const { optionalText } = this.props;
      return <FormLabelCopyAddOnStyled>{optionalText}</FormLabelCopyAddOnStyled>;
    };

    const renderStateLabelCopyAddOn = (type) => {
      let image;
      if (type === 'search') {
        image = <SearchSvg />;
      } else {
        image = <SelectArrowSvg />;
      }

      return <FormLabelSvgAddOnStyled>{image}</FormLabelSvgAddOnStyled>;
    };

    const renderPrivacyPolicy = () => {
      const { privacyPolicy, privacyPolicyURL } = this.props;
      return (
        <PrivacyPolicyStyled>
          <TextLink
            url={privacyPolicyURL}
            text={privacyPolicy}
            linkName="PAYMENT_ESTIMATOR_LEADS_FORM_PRIVACY_POLICY"
            className="privacy-policy-leads"
          />
        </PrivacyPolicyStyled>
      );
    };

    const renderPhoneFormat = (event) => {
      let currentValue = event.currentTarget.value;

      // work with only digits
      let currentValueSanitized = currentValue.replace(/[^0-9]/g, '').substring(0, 10);

      // allow for special characters: (
      let phoneNumber = currentValue.replace(/((?![(]))[^0-9]/g, '').substring(0, 10);

      const deleteKey = event.keyCode === 8 || event.keyCode === 46 ? true : false;
      const size = currentValueSanitized.length;

      if (size === 0) {
        currentValue === '(' ? (phoneNumber = '(') : (phoneNumber = '');
      } else if (size < 3) {
        phoneNumber = '(' + currentValueSanitized;
      } else if (size === 3) {
        phoneNumber = '(' + currentValueSanitized + (deleteKey ? '' : ') ');
      } else if (size < 6) {
        phoneNumber = '(' + currentValueSanitized.substring(0, 3) + ') ' + currentValueSanitized.substring(3, 6);
      } else if (size === 6) {
        phoneNumber =
          '(' +
          currentValueSanitized.substring(0, 3) +
          ') ' +
          currentValueSanitized.substring(3, 6) +
          (deleteKey ? '' : '-');
      } else {
        phoneNumber =
          '(' +
          currentValueSanitized.substring(0, 3) +
          ') ' +
          currentValueSanitized.substring(3, 6) +
          '-' +
          currentValueSanitized.substring(6, 10);
      }
      event.currentTarget.value = phoneNumber;
      this.props.handleChange(event);
    };

    const renderFormFields = (formFields) => {
      return formFields.map((field) => (
        <FormLabelOuterWrapperStyled
          key={field.name}
          type={field.type}
          width={field.width}
          display={field.display}
          padding={field.padding}
          fieldError={renderFieldError(field)}
        >
          {errors[field.name] &&
            touched[field.name] && (
              <FormInlineErrorWrapperStyled fieldError={renderFieldError(field)}>
                <FormInlineErrorStyled>
                  <FormInlineErrorSvgWrapperStyled>
                    <ErrorSvg />
                  </FormInlineErrorSvgWrapperStyled>
                  <FormInlineErrorCopyStyled>{errors[field.name]}</FormInlineErrorCopyStyled>
                </FormInlineErrorStyled>
              </FormInlineErrorWrapperStyled>
            )}

          <FormLabelInnerWrapperStyled fieldError={renderFieldError(field)} type={field.type}>
            <FormLabelCopyStyled type={field.type} fieldError={renderFieldError(field)}>
              {field.label}
              {field.labelCopyAddOn ? field.labelCopyAddOn : null}
            </FormLabelCopyStyled>
            {field.type === 'select' ? renderFormSelect(field) : renderFormInput(field)}
            {renderCheckboxLabel(field)}
          </FormLabelInnerWrapperStyled>
        </FormLabelOuterWrapperStyled>
      ));
    };

    return (
      <FormStyled onSubmit={handleSubmit} hideForm={this.props.hideForm} autoComplete="on" className='payment-estimator-leads-form'>
        {this.props.genericErrors && (
          <GenericFormErrorStyled>
            <GenericFormErrorSvgStyled>
              <ErrorSvg />
            </GenericFormErrorSvgStyled>
            {unknownError}
          </GenericFormErrorStyled>
        )}
        <StyledInfoTextWrapper>
          <StyledInfoText>{infoText}</StyledInfoText>
          <StyledInfoText>{requiredText}</StyledInfoText>
        </StyledInfoTextWrapper>
        {renderFormFields([
          {
            name: FIELD_NAMES.FIRST_NAME,
            type: 'text',
            label: firstName,
            placeholder: null,
            autoComplete: 'given-name',
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 50 },
            padding: { small: '0', large: '0 5%' }
          },
          {
            name: FIELD_NAMES.LAST_NAME,
            type: 'text',
            label: lastName,
            placeholder: null,
            autoComplete: 'family-name',
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 50 },
            padding: { small: '0', large: '0 5%' }
          },
          {
            name: FIELD_NAMES.ADDRESS,
            type: 'text',
            label: address,
            placeholder: null,
            autoComplete: 'street-address',
            display: { small: 'block', large: 'block' },
            width: { small: 100, large: 100 },
            padding: { small: '0', large: '0' }
          },
          {
            name: FIELD_NAMES.CITY,
            type: 'text',
            label: city,
            placeholder: null,
            autoComplete: 'address-level2',
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 33 },
            padding: { small: '0', large: '0 5%' }
          },
          {
            name: FIELD_NAMES.STATE,
            type: 'select',
            label: state,
            placeholder: null,
            autoComplete: 'address-level1',
            display: { small: 'inline-block', large: 'inline-block' },
            width: { small: 50, large: 33 },
            padding: { small: '0 10px 0 0', large: '0 1% 0 5%' },
          },
          {
            name: FIELD_NAMES.ZIP_CODE,
            type: 'text',
            label: zipCode,
            placeholder: null,
            autoComplete: 'postal-code',
            maxLength: 5,
            display: { small: 'inline-block', large: 'inline-block' },
            width: { small: 50, large: 33 },
            padding: { small: '0 0 0 10px', large: '0 5% 0 1%' }
          },
          {
            name: FIELD_NAMES.EMAIL,
            type: 'text',
            label: email,
            placeholder: null,
            autoComplete: 'email',
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 50 },
            padding: { small: '0', large: '0 5%' }
          },
          {
            name: FIELD_NAMES.PHONE,
            type: 'text',
            label: phone,
            placeholder: null,
            autoComplete: 'tel-national',
            maxLength: 14,
            onChange: renderPhoneFormat,
            onKeyDown: renderPhoneFormat,
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 50 },
            padding: { small: '0', large: '0 5%' },
            labelCopyAddOn: renderPhoneLabelCopyAddOn()
          },
          {
            name: FIELD_NAMES.NEWS,
            type: 'checkbox',
            label: optIn,
            placeholder: null,
            autoComplete: 'off',
            id: 'newsletter-signup',
            display: { small: 'block', large: 'inline-block' },
            width: { small: 100, large: 100 },
            padding: { small: '0', large: '0 5%' }
          }
        ])}
        {renderPrivacyPolicy()}
        <FormButtonWrapperStyled type="submit" disabled={isSubmitting}>
          <Button
            type="submit"
            width="auto"
            text={submitButton}
            onClick={(e) => {
              handleSubmit(e);
            }}
            float={brandName === 'nissan' ? 'left' : 'none'}
          />
        </FormButtonWrapperStyled>
      </FormStyled>
    );
  }
}

const FormMarkupWithFormik = withFormik({
  mapPropsToValues: () => ({
    [FIELD_NAMES.FIRST_NAME]: '',
    [FIELD_NAMES.LAST_NAME]: '',
    [FIELD_NAMES.ADDRESS]: '',
    [FIELD_NAMES.CITY]: '',
    [FIELD_NAMES.STATE]: '',
    [FIELD_NAMES.ZIP_CODE]: '',
    [FIELD_NAMES.EMAIL]: '',
    [FIELD_NAMES.NEWS]: true,
    [FIELD_NAMES.PHONE]: ''
  }),
  validationSchema: props =>
    Yup.object().shape({
      [FIELD_NAMES.FIRST_NAME]: Yup.string()
        .max(30)
        .required(props.firstNameError),
      [FIELD_NAMES.LAST_NAME]: Yup.string()
        .max(30)
        .required(props.lastNameError),
      [FIELD_NAMES.ADDRESS]: Yup.string().required(props.addressError),
      [FIELD_NAMES.CITY]: Yup.string().required(props.cityError),
      [FIELD_NAMES.STATE]: Yup.string().required(props.stateError),
      [FIELD_NAMES.ZIP_CODE]: Yup.string()
        .required(props.zipCodeError)
        .matches(/^((?!00000)[0-9]{5})$/, props.invalidZipCode),
      [FIELD_NAMES.EMAIL]: Yup.string()
        .email(props.invalidEmail)
        .required(props.emailError),
      [FIELD_NAMES.NEWS]: Yup.boolean(),
      [FIELD_NAMES.PHONE]: Yup.string()
        .notRequired()
        .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, props.invalidPhone)
    }),
  handleSubmit: (values, { props }) => {
    const { currentFormValues, currentZip, setNewZipCode } = props;
    currentFormValues(values);
  },
  displayName: 'LeadForm'
})(FormMarkup);

class LeadForm extends Component {
  static propTypes = {
    firstNameError: PropTypes.string,
    lastNameError: PropTypes.string,
    addressError: PropTypes.string,
    cityError: PropTypes.string,
    stateError: PropTypes.string,
    invalidEmail: PropTypes.string,
    emailError: PropTypes.string,
    invalidPhone: PropTypes.string,
    zipCodeError: PropTypes.string,
    invalidZipCode: PropTypes.string
  };
  static defaultProps = {
    firstNameError: geti18n('leadsFormContent.leadsForm.firstNameError'),
    lastNameError: geti18n('leadsFormContent.leadsForm.lastNameError'),
    addressError: geti18n('leadsFormContent.leadsForm.addressError'),
    cityError: geti18n('leadsFormContent.leadsForm.cityError'),
    stateError: geti18n('leadsFormContent.leadsForm.stateError'),
    invalidEmail: geti18n('leadsFormContent.leadsForm.invalidEmail'),
    emailError: geti18n('leadsFormContent.leadsForm.emailError'),
    invalidPhone: geti18n('leadsFormContent.leadsForm.invalidPhone'),
    zipCodeError: geti18n('leadsFormContent.dealerListZipSearch.zipCodeRequired'),
    invalidZipCode: geti18n('leadsFormContent.dealerListZipSearch.zipCodeInvalid')
  };

  render() {
    const {
      currentFormValues,
      formErrors,
      genericErrors,
      setNewZipCode,
      formErrorCallback,
      hideForm,
      firstNameError,
      lastNameError,
      addressError,
      cityError,
      stateError,
      invalidEmail,
      invalidPhone,
      emailError,
      zipCodeError,
      invalidZipCode
    } = this.props;
    return (
      <FormMarkupWithFormik
        setNewZipCode={setNewZipCode}
        hideForm={hideForm}
        currentFormValues={currentFormValues}
        formErrors={formErrors}
        genericErrors={genericErrors}
        formErrorCallback={formErrorCallback}
        firstNameError={firstNameError}
        lastNameError={lastNameError}
        addressError={addressError}
        cityError={cityError}
        stateError={stateError}
        invalidEmail={invalidEmail}
        invalidPhone={invalidPhone}
        emailError={emailError}
        zipCodeError={zipCodeError}
        invalidZipCode={invalidZipCode}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  currentZip: getCurrentZipCode(state),
  brandName: getBrandFromState(state)
});

const mapDispatchToProps = (dispatch) => ({
  setNewZipCode: bindActionCreators(updateZipCodeAction, dispatch)
});

export default (connect(mapStateToProps, mapDispatchToProps)(LeadForm));



/** WEBPACK FOOTER **
 ** ./src/components/LeadsForm/index.js
 **/